export default __webpack_public_path__ + "static/media/50.bdf5bc15.jpeg";